'use client';

import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { usePathname } from '@/i18n/navigation';
import Image from '@/components/image';
import StarIcon from '@/components/ui/icons/star-icon';

const STORAGE_KEY = 'app_install_banner';

const AppInstallBanner = () => {
  const t = useTranslations('app_install_banner');
  const pathname = usePathname();
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    if (!sessionStorage.getItem(STORAGE_KEY)) setDismissed(false);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setDismissed(true);
  };

  if (dismissed || pathname === '/checkout') return null;

  return (
    <div className='fixed right-0 bottom-0 left-0 z-50 hidden max-lg:block'>
      <div className='w-full overflow-hidden bg-white shadow-[0_-6px_20px_rgba(2,6,23,0.12)]'>
        <div className='bg-primary px-3 py-2 text-center text-xs font-semibold text-white'>
          {t('description')}
        </div>
        <div className='flex items-center gap-3 p-3'>
          <Image
            src='/imgs/app_logo.webp'
            alt='app icon'
            width={56}
            height={56}
            className='h-16 w-16 rounded-xl object-contain'
          />
          <div className='min-w-0 flex-1'>
            <p className='truncate text-sm font-bold text-gray-900'>
              {t('title')}
            </p>
            <div className='mt-1 flex items-center gap-0.5'>
              {Array.from({ length: 5 }).map((_, i) => (
                <StarIcon
                  key={i}
                  size={16}
                  fill='currentColor'
                  stroke='none'
                  className='text-yellow-400'
                />
              ))}
            </div>
          </div>
        </div>
        <div className='flex items-stretch gap-2 px-3 pb-3'>
          <button
            type='button'
            onClick={dismiss}
            className='flex-1 rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-xs font-semibold text-gray-700'
          >
            {t('cta_stay')}
          </button>
          <a
            href='https://innova.dynalinks.app/store'
            target='_blank'
            rel='noopener noreferrer'
            onClick={dismiss}
            className='bg-primary flex flex-1 items-center justify-center rounded-lg px-3 py-2.5 text-xs font-semibold text-white'
          >
            {t('cta_install')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppInstallBanner;
